import React from 'react';
import styled from 'styled-components';
import useContentAsociacionUsuariosNomatividad from '../hooks/parameter/useContentAsociacionUsuariosNomatividad.js';
import useContentModeradora from '../hooks/parameter/useContentModeradora.js';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 400px;
  max-width: 1200px;

  p {
    text-align: center;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PageNormatividad = () => {
  window.scroll(0, 0);
  const { asociacionUsuariosNomatividad } =
    useContentAsociacionUsuariosNomatividad();
  const bodyHTML =
    asociacionUsuariosNomatividad.length > 0 &&
    asociacionUsuariosNomatividad[0].texto_completo;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <DivContainer id='contBodyHTML'>
          <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
        </DivContainer>
      </div>
    </>
  );
};
